import React from "react";
import { useTranslation } from "react-i18next";

export default function PaymentMethodRow(element: any) {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {element.element.selectedRow?.subRows !== undefined ? (
                <h6 className="badge__clz mdr_icn_BTcounter">
                    {element.element.selectedRow?.Boutique !== ""
                        ? element.element.selectedRow.subRows?.length
                        : 0}
                </h6>
            ) : (
                element.element.selectedRow[t("Payment method")]
            )}
        </React.Fragment>
    );
}
